import React, { ComponentType } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Open Sans, sans-serif'
  }
});
const customGlobalStyles = `
  body, td, th, input, select, textarea, button, [class^="k-"]:not(.k-icon) {
    font-family: 'Open Sans', sans-serif;
    font-size: 13px;
  }
`;

function ApplyTheme<P>(Component: ComponentType<P>): ComponentType<P> {
  return (props: P) => (
    <ThemeProvider theme={theme}>
      <style>{customGlobalStyles}</style>
      <Component {...props} />
    </ThemeProvider>
  );
}
export default ApplyTheme;
